export default __webpack_public_path__ + "static/media/healthwise.dd031d5b.svg";